exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-container[data-v-514d2b58] {\n  border: 1px dashed var(--theme-gray);\n  width: 45%;\n  padding: 1em 1.4em;\n  min-height: 9em;\n  min-width: 16em;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n@media (max-width: 1100px) {\n.main-container[data-v-514d2b58] {\n    width: 49%;\n    margin-left: 0rem;\n    margin-right: 0rem;\n}\n}\n@media (max-width: 1000px) {\n.main-container[data-v-514d2b58] {\n    width: 90%;\n    height: 8em;\n}\n}\n@media (max-width: 600px) {\n.main-container[data-v-514d2b58] {\n    height: 6em;\n    width: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-514d2b58","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/selectBox/AddPhone.vue
// module id = 789
// module chunks = 0